import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, message, Row, Col, Select, Spin, Checkbox } from 'antd';
import { graphql, compose, Query } from 'react-apollo';
import validationRegex from '@eumentis-cloud/js-validation-regex';
import moment from 'moment';

import AllOpenMeetingTopicsQuery from '../graphql/queries/allOpenMeetingTopicsQuery.graphql';
import MUTATION from '../graphql/mutations/newRetainerClientMeetingMinutesMutation.graphql';
import NewRetainerClientAssignmentForm from './NewRetainerClientAssignmentForm';

const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 12 },
};

class NewRetainerClientMeetingMinutesForm extends Component {
  state = {
    submittingForm: false,
    assignmentMinutesKeys: [],
    nextKey: 0,
    meetingTopicsKeys: [],
    nextMeetingTopicsKey: 0,
  };

  add = () => {
    const { nextKey, assignmentMinutesKeys } = this.state;
    this.setState({
      assignmentMinutesKeys: [...assignmentMinutesKeys, nextKey],
      nextKey: nextKey + 1,
    });
  };

  remove = (key) => {
    const { assignmentMinutesKeys } = this.state;
    this.setState({
      assignmentMinutesKeys: assignmentMinutesKeys.filter((entry) => entry !== key),
    });
  };

  addMeetingTopic = () => {
    const { nextMeetingTopicsKey, meetingTopicsKeys } = this.state;
    this.setState({
      meetingTopicsKeys: [...meetingTopicsKeys, nextMeetingTopicsKey],
      nextMeetingTopicsKey: nextMeetingTopicsKey + 1,
    });
  };

  removeMeetingTopic = (key) => {
    const { meetingTopicsKeys } = this.state;
    this.setState({
      meetingTopicsKeys: meetingTopicsKeys.filter((entry) => entry !== key),
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submittingForm: true,
    });

    const { form, mutate, match, history } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { assignmentMinutesKeys, meetingTopicsKeys } = this.state;
        const valuesToSubmit = values;
        valuesToSubmit.attendees = values.attendees.split(',').map((entry) => entry.trim());
        if (assignmentMinutesKeys.length > 0) {
          valuesToSubmit.assignmentsMinutes = assignmentMinutesKeys.map((entry) => values.assignmentsMinutes[entry]);
        }
        if (meetingTopicsKeys.length > 0) {
          valuesToSubmit.newMeetingTopicsMinutes = meetingTopicsKeys.map(
            (entry) => values.newMeetingTopicsMinutes[entry],
          );
        }
        mutate({
          variables: { retainerClientId: parseInt(match.params.clientId, 10), ...valuesToSubmit },
          refetchQueries: ['allOpenMeetingTopics'],
        })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            history.goBack();
            message.success('New minutes of meeting created!');
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm, assignmentMinutesKeys, meetingTopicsKeys } = this.state;
    const { form, ongoingAssignments, match } = this.props;
    const { getFieldDecorator } = form;

    return (
      <div className="contentBox">
        <h1>New minutes of meeting</h1>
        <Form layout="horizontal" onSubmit={this.handleSubmit}>
          <FormItem label="Internal Meeting?" {...formItemLayout}>
            {getFieldDecorator('internalMeeting', {
              initialValue: true,
            })(<Checkbox disabled={submittingForm}>Select if you dont want to show this meeting to client</Checkbox>)}
          </FormItem>
          <FormItem label="Meeting Date" hasFeedback {...formItemLayout}>
            {getFieldDecorator('date', {
              initialValue: moment().format('YYYY-MM-DD'),
              rules: [
                { required: true, message: 'Field is required!' },
                { pattern: validationRegex.dateString, message: 'Incorrect format! The correct format = YYYY-MM-DD' },
              ],
            })(<Input disabled placeholder="YYYY-MM-DD" />)}
          </FormItem>
          <FormItem label="Attendees (comma separated)" hasFeedback {...formItemLayout}>
            {getFieldDecorator('attendees', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<Input disabled={submittingForm} placeholder="Name 1, Name 2, Name 3, ..." />)}
          </FormItem>
          <FormItem label="Agenda" hasFeedback {...formItemLayout}>
            {getFieldDecorator('agenda', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<TextArea disabled={submittingForm} autosize={{ minRows: 3, maxRows: 6 }} />)}
          </FormItem>

          <h2 style={{ margin: '20px 0' }}>Old Meeting Topics</h2>
          <Query
            query={AllOpenMeetingTopicsQuery}
            variables={{ retainerClientId: parseInt(match.params.clientId, 10) }}
          >
            {({ loading, error, data }) => {
              if (loading) return <Spin />;
              if (error) return <p>Error: {error.message}</p>;
              const { allOpenMeetingTopics } = data;

              if (allOpenMeetingTopics.length < 1) {
                return <p>All old meeting topics completed!</p>;
              }

              return (
                <div>
                  {allOpenMeetingTopics.map((entry, index) => (
                    <Row gutter={20} style={{ marginTop: 20, borderBottom: '1px solid #EEEEEE' }} key={entry.id}>
                      <Col span={8}>
                        <FormItem style={{ display: 'none' }}>
                          {getFieldDecorator(`oldMeetingTopicsMinutes[${index}].retainerMeetingTopicId`, {
                            initialValue: entry.id,
                            rules: [{ required: true, message: 'Field is required!' }],
                          })(<Input style={{ display: 'none' }} />)}
                        </FormItem>
                        <p>
                          <strong>Title: </strong>
                          <br />
                          {entry.title}
                        </p>
                        <p>
                          <strong>Start Date: </strong>
                          <br />
                          {moment(new Date(entry.startDate)).format('Do MMM, YYYY')}
                        </p>
                      </Col>
                      <Col span={16}>
                        <FormItem label="Discussion" hasFeedback>
                          {getFieldDecorator(`oldMeetingTopicsMinutes[${index}].discussion`, {
                            rules: [{ required: true, message: 'Field is required!' }],
                          })(<TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />)}
                        </FormItem>
                        <FormItem label="Suggestions / Opinions">
                          {getFieldDecorator(`oldMeetingTopicsMinutes[${index}].suggestion`)(
                            <TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />,
                          )}
                        </FormItem>
                        <FormItem label="Client Feedback">
                          {getFieldDecorator(`oldMeetingTopicsMinutes[${index}].clientFeedback`)(
                            <TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />,
                          )}
                        </FormItem>
                        <FormItem label="End Meeting Topic">
                          {getFieldDecorator(`oldMeetingTopicsMinutes[${index}].endTopic`, { initialValue: false })(
                            <Checkbox disabled={submittingForm}>
                              Select if you want to end this topic in this meeting
                            </Checkbox>,
                          )}
                        </FormItem>
                      </Col>
                    </Row>
                  ))}
                </div>
              );
            }}
          </Query>

          <h2 style={{ margin: '20px 0' }}>New Meeting Topics</h2>
          <Button htmlType="button" onClick={this.addMeetingTopic} disabled={submittingForm}>
            Create Meeting Topic
          </Button>
          {meetingTopicsKeys.map((key) => (
            <Row gutter={20} style={{ marginTop: 20, borderBottom: '1px solid #EEEEEE' }} key={key}>
              <Col span={8}>
                <FormItem label="Title" hasFeedback>
                  {getFieldDecorator(`newMeetingTopicsMinutes[${key}].title`, {
                    rules: [{ required: true, message: 'Field is required!' }],
                  })(<TextArea disabled={submittingForm} autosize={{ minRows: 4, maxRows: 6 }} />)}
                </FormItem>
                <Button
                  htmlType="button"
                  type="danger"
                  onClick={() => this.removeMeetingTopic(key)}
                  disabled={submittingForm}
                >
                  Remove this topic
                </Button>
              </Col>
              <Col span={16}>
                <FormItem label="Discussion" hasFeedback>
                  {getFieldDecorator(`newMeetingTopicsMinutes[${key}].discussion`, {
                    rules: [{ required: true, message: 'Field is required!' }],
                  })(<TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />)}
                </FormItem>
                <FormItem label="Suggestions / Opinions">
                  {getFieldDecorator(`newMeetingTopicsMinutes[${key}].suggestion`)(
                    <TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />,
                  )}
                </FormItem>
                <FormItem label="Client Feedback">
                  {getFieldDecorator(`newMeetingTopicsMinutes[${key}].clientFeedback`)(
                    <TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />,
                  )}
                </FormItem>
                <FormItem label="End Meeting Topic">
                  {getFieldDecorator(`newMeetingTopicsMinutes[${key}].endTopic`, { initialValue: false })(
                    <Checkbox disabled={submittingForm}>Select if you want to end this topic in this meeting</Checkbox>,
                  )}
                </FormItem>
              </Col>
            </Row>
          ))}

          <h2 style={{ margin: '20px 0' }}>Assignment Minutes</h2>
          <Button htmlType="button" onClick={this.add} disabled={submittingForm}>
            Add Assignment
          </Button>
          {assignmentMinutesKeys.map((key) => (
            <Row gutter={20} style={{ marginTop: 20 }} key={key}>
              <Col span={6}>
                <FormItem label="Select Assignment">
                  {getFieldDecorator(`assignmentsMinutes[${key}].retainerClientAssignmentId`, {
                    rules: [{ required: true, message: 'Field is required!' }],
                  })(
                    <Select disabled={submittingForm}>
                      {ongoingAssignments.map((entry) => (
                        <Option key={entry.id} value={entry.id}>
                          {entry.title}
                        </Option>
                      ))}
                    </Select>,
                  )}
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="Discussion" hasFeedback>
                  {getFieldDecorator(`assignmentsMinutes[${key}].discussion`, {
                    rules: [{ required: true, message: 'Field is required!' }],
                  })(<TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />)}
                </FormItem>
                <FormItem label="Suggestions / Opinions">
                  {getFieldDecorator(`assignmentsMinutes[${key}].suggestion`)(
                    <TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />,
                  )}
                </FormItem>
                <FormItem label="Client Feedback">
                  {getFieldDecorator(`assignmentsMinutes[${key}].clientFeedback`)(
                    <TextArea disabled={submittingForm} autosize={{ minRows: 2, maxRows: 4 }} />,
                  )}
                </FormItem>
              </Col>
              <Col span={6}>
                <Button htmlType="button" type="danger" onClick={() => this.remove(key)} disabled={submittingForm}>
                  Remove Assignment Meeting
                </Button>
              </Col>
            </Row>
          ))}

          <h2 style={{ margin: '20px 0' }}>Meeting Summary</h2>
          <FormItem label="Discussion" hasFeedback {...formItemLayout}>
            {getFieldDecorator('discussion', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<TextArea disabled={submittingForm} autosize={{ minRows: 3, maxRows: 6 }} />)}
          </FormItem>
          <FormItem label="Suggestions / Opinions" {...formItemLayout}>
            {getFieldDecorator('suggestion')(
              <TextArea disabled={submittingForm} autosize={{ minRows: 3, maxRows: 6 }} />,
            )}
          </FormItem>
          <FormItem label="Client Feedback" {...formItemLayout}>
            {getFieldDecorator('clientFeedback')(
              <TextArea disabled={submittingForm} autosize={{ minRows: 3, maxRows: 6 }} />,
            )}
          </FormItem>
          <FormItem label="Conclusion" hasFeedback {...formItemLayout}>
            {getFieldDecorator('conclusion', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<TextArea disabled={submittingForm} autosize={{ minRows: 3, maxRows: 6 }} />)}
          </FormItem>

          <FormItem>
            <Button type="primary" htmlType="submit" loading={submittingForm}>
              Submit
            </Button>
          </FormItem>
        </Form>

        <h1>Create new assignment</h1>
        <NewRetainerClientAssignmentForm retainerClientId={parseInt(match.params.clientId, 10)} />
      </div>
    );
  }
}

NewRetainerClientMeetingMinutesForm.propTypes = {
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      clientId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  ongoingAssignments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ).isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(NewRetainerClientMeetingMinutesForm);



// WEBPACK FOOTER //
// ./src/forms/NewRetainerClientMeetingMinutesForm.jsx